
import Vue from 'vue'
import InputText from '~/components/atoms/InputText.vue'

export default Vue.extend({
  components: {
    InputText,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: '',
    }
  },
})
